import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

const FocusList = ({ items, prefix }) => {
	// Convert objects to arrays, assuming there is only one item in the array.
	const listOfArrays = (items || []).map(_.values);
	// Combine (or flatten) all values so it's a simple array of strings.
	return _.flatten(listOfArrays)
		.map(item =>
			<li key={_.uniqueId('list-item-')}>{prefix} {item}</li>);
};

FocusList.propTypes = {
	items: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.bool,
	]),
	prefix: PropTypes.string,
};

FocusList.defaultProps = {
	items: [],
	prefix: '',
};

export default FocusList;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/focus-list.js